export default __webpack_public_path__ + "static/adopted-dogs-banner-bg-eac77f6a1d5023c18e6f72b46b974bbc.jpg";